import { Theme } from '@mui/material';

export const socialButtonsStyles = (theme: Theme, color?: string) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		gap: {
			xs: '8px',
			sm: '10px',
		},
	},
	button: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color,
	},
	icon: {
		width: '35px',
		height: '35px',
	},
	facebookIcon: {
		width: '35px',
		height: '27px',
		mt: '2px',
	},
});
